import React from 'react';
import { useModalContentView } from './ContentViewContext';
import { FreemiumUpsellScreen } from '../settings/manage-subscription/freemium';
import SessionTimeoutModal from '../SessionTimeoutModal';
import { useAuthenticatedFlag } from '../../hooks';
import { useDeviceType } from '../../hooks/useDeviceType';
import FindYourInstitutionModal from '../account-details/link-account/find-institution/FindYourInstitutionModal';

const AppModal: React.FC = () => {
  const { isMobile, isTablet } = useDeviceType();
  const mobile = isMobile || isTablet;
  const { isModalOpen, closeModal } = useModalContentView();
  const isAuthenticated = useAuthenticatedFlag();

  return (
    <>
      {isAuthenticated && <SessionTimeoutModal />}

      <FreemiumUpsellScreen
        open={isModalOpen('upsell')}
        handleClose={() => closeModal('upsell')}
        mobile={mobile}
      />

      <FindYourInstitutionModal />

      {/* Add additional global modals here */}
    </>
  );
};

export default AppModal;
